import { map } from "rxjs";
import { GET, POST, PUT } from "../../../../module/services/fetch";
import { ICreateConflictBody, IEditExceptionBody } from "./constants";

export const fetchGetSodConflicts = () =>
  GET(`sod/conflicts`).pipe(map((response: any) => response));

export const fetchDeleteSodConflict = (body: string[]) =>
  POST(`sod/admin/conflicts/delete`, body).pipe(
    map((response: any) => response)
  );

export const fetchGetAllEntitlements = (payload: any) => {
  const { callBody, sortBy } = payload;
  return POST(
    `entitlements/find${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    callBody
  ).pipe(map((response: any) => response));
};

export const fetchCreateConflict = (body: ICreateConflictBody) =>
  POST(`sod/admin/conflicts`, body).pipe(map((response: any) => response));

export const fetchModifyConflictType = (queryParams: string) =>
  PUT(`sod/admin/conflicts${queryParams}`).pipe(
    map((response: any) => response)
  );

export const fetchGetConflictException = (conflictId: string) =>
  GET(`sod/conflicts/${conflictId}/exceptions`).pipe(
    map((response: any) => response)
  );

export const fetchEditConflictException = (
  exceptionId: string,
  body: IEditExceptionBody
) =>
  PUT(`sod/admin/conflicts/exceptions/${exceptionId}`, body).pipe(
    map((response: any) => response)
  );

export const fetchDeleteConflictException = (body: string[]) =>
  POST(`sod/admin/conflicts/exceptions/delete`, body).pipe(
    map((response: any) => response)
  );

export const fetchGetAllUsers = (payload: any) => {
  const { callBody, sortBy } = payload;
  return POST(
    `admin/users/find${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    callBody
  ).pipe(map((response: any) => response));
};

export const fetchCreateException = (body: IEditExceptionBody) =>
  POST(`sod/admin/conflicts/exceptions`, body).pipe(
    map((response: any) => response)
  );
